exports = module.exports = require("../../../../../../../../css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".flatCard{background-color:#f5f5f5;padding:15px;border-radius:20px;margin:10px}", "",{"version":3,"sources":["FlatCard.styles.scss"],"names":[],"mappings":"AACA,UACE,wBAAA,CACA,YAAA,CACA,kBAAA,CACA,WAAA","file":"FlatCard.styles.scss","sourcesContent":["$theme: zam;\n.flatCard {\n  background-color: #f5f5f5;\n  padding: 15px;\n  border-radius: 20px;\n  margin: 10px;\n}\n"]}]);

// Exports
exports.locals = {
	"flatCard": "flatCard"
};